var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBuilderTestscores(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.628,
    height: 47,
    viewBox: "0 0 42.628 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(-2.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55647",
    "data-name": "Path 55647",
    d: "M38.866,1.25H8.262A6.012,6.012,0,0,0,2.25,7.262V42.238A6.012,6.012,0,0,0,8.262,48.25h30.6a6.012,6.012,0,0,0,6.012-6.012V7.262A6.012,6.012,0,0,0,38.866,1.25ZM20.35,35.2,14.82,40.664a1.64,1.64,0,0,1-2.317,0L9.223,37.385a1.64,1.64,0,0,1,2.317-2.317l2.186,2.186L18.1,32.882A1.64,1.64,0,1,1,20.416,35.2Zm0-12.023L14.82,28.641a1.64,1.64,0,0,1-2.317,0L9.223,25.362a1.64,1.64,0,0,1,2.317-2.317l2.186,2.186L18.1,20.859a1.64,1.64,0,0,1,2.317,2.317Zm0-12.023L14.82,16.618a1.64,1.64,0,0,1-2.186,0L9.355,13.339a1.64,1.64,0,0,1,2.252-2.317l2.186,2.186,4.372-4.372a1.64,1.64,0,0,1,2.317,2.317ZM36.68,38.959H25.75a1.64,1.64,0,1,1,0-3.279H36.68a1.64,1.64,0,0,1,0,3.279Zm0-12.023H25.75a1.64,1.64,0,1,1,0-3.279H36.68a1.64,1.64,0,0,1,0,3.279Zm0-12.023H25.75a1.64,1.64,0,1,1,0-3.279H36.68a1.64,1.64,0,0,1,0,3.279Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderTestscores);
export default __webpack_public_path__ + "static/media/profile-builder-testscores.c0364a2ee2e041b494782dfff36d4adc.svg";
export { ForwardRef as ReactComponent };